import {
  AspectRatio,
  Box,
  Button,
  CloseButton,
  Dialog,
  HStack,
  Portal,
  Text,
} from "@chakra-ui/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import { MAIN_TUTORIALS, PROCESS_TUTORIALS } from "@/config/tutorials";

const TUTORIALS = [...MAIN_TUTORIALS, ...PROCESS_TUTORIALS];

type Props = { open: boolean; onClose: () => void };

const TutorialsSlideshowModal = ({ open, onClose }: Props): JSX.Element => {
  const [index, setIndex] = useState(0);
  const tutorial = TUTORIALS[index];

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => !e.open && onClose()}
      size="xl"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content borderRadius="md" maxWidth="860px">
            <Dialog.Header>
              <Box>
                <Text fontSize="xs" color="gray.500">
                  Video {index + 1} de {TUTORIALS.length}
                </Text>
                <Dialog.Title fontSize="lg" fontWeight="semibold">
                  {tutorial.title}
                </Dialog.Title>
              </Box>
            </Dialog.Header>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
            <Dialog.Body>
              <Text fontSize="sm" color="gray.600" mb={3}>
                {tutorial.description}
              </Text>
              <AspectRatio ratio={16 / 9} rounded="md" overflow="hidden">
                <iframe
                  key={tutorial.id}
                  src={tutorial.embedUrl}
                  title={tutorial.title}
                  allowFullScreen
                />
              </AspectRatio>
            </Dialog.Body>
            <Dialog.Footer justifyContent="space-between">
              <Button
                variant="outline"
                size="sm"
                disabled={index === 0}
                onClick={() => setIndex((i) => i - 1)}
              >
                <ChevronLeft size={16} />
                Anterior
              </Button>
              <HStack gap={1.5}>
                {TUTORIALS.map((t, i) => (
                  <Box
                    key={t.id}
                    as="button"
                    w="8px"
                    h="8px"
                    rounded="full"
                    bg={i === index ? "palomma.500" : "gray.300"}
                    onClick={() => setIndex(i)}
                  />
                ))}
              </HStack>
              <Button
                colorPalette="palomma"
                size="sm"
                disabled={index === TUTORIALS.length - 1}
                onClick={() => setIndex((i) => i + 1)}
              >
                Siguiente
                <ChevronRight size={16} />
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default TutorialsSlideshowModal;
